/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MappedInitiativeRefDto } from './MappedInitiativeRefDto';
import {
    MappedInitiativeRefDtoFromJSON,
    MappedInitiativeRefDtoFromJSONTyped,
    MappedInitiativeRefDtoToJSON,
    MappedInitiativeRefDtoToJSONTyped,
} from './MappedInitiativeRefDto';

/**
 * 
 * @export
 * @interface CsfSubcategoryCoverageRowDto
 */
export interface CsfSubcategoryCoverageRowDto {
    /**
     * 
     * @type {string}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    covered?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    breadthRatio?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    mappedActiveInitiativeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    depthCmmi?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    normalizedDepth?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    partialDepth?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    initiativesContributingToDepthCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    compositeScore?: number;
    /**
     * 
     * @type {number}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    compositeCmmi?: number;
    /**
     * 
     * @type {Array<MappedInitiativeRefDto>}
     * @memberof CsfSubcategoryCoverageRowDto
     */
    mappedInitiatives?: Array<MappedInitiativeRefDto>;
}

/**
 * Check if a given object implements the CsfSubcategoryCoverageRowDto interface.
 */
export function instanceOfCsfSubcategoryCoverageRowDto(value: object): value is CsfSubcategoryCoverageRowDto {
    return true;
}

export function CsfSubcategoryCoverageRowDtoFromJSON(json: any): CsfSubcategoryCoverageRowDto {
    return CsfSubcategoryCoverageRowDtoFromJSONTyped(json, false);
}

export function CsfSubcategoryCoverageRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CsfSubcategoryCoverageRowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'title': json['title'] == null ? undefined : json['title'],
        'covered': json['covered'] == null ? undefined : json['covered'],
        'breadthRatio': json['breadthRatio'] == null ? undefined : json['breadthRatio'],
        'mappedActiveInitiativeCount': json['mappedActiveInitiativeCount'] == null ? undefined : json['mappedActiveInitiativeCount'],
        'depthCmmi': json['depthCmmi'] == null ? undefined : json['depthCmmi'],
        'normalizedDepth': json['normalizedDepth'] == null ? undefined : json['normalizedDepth'],
        'partialDepth': json['partialDepth'] == null ? undefined : json['partialDepth'],
        'initiativesContributingToDepthCount': json['initiativesContributingToDepthCount'] == null ? undefined : json['initiativesContributingToDepthCount'],
        'compositeScore': json['compositeScore'] == null ? undefined : json['compositeScore'],
        'compositeCmmi': json['compositeCmmi'] == null ? undefined : json['compositeCmmi'],
        'mappedInitiatives': json['mappedInitiatives'] == null ? undefined : ((json['mappedInitiatives'] as Array<any>).map(MappedInitiativeRefDtoFromJSON)),
    };
}

export function CsfSubcategoryCoverageRowDtoToJSON(json: any): CsfSubcategoryCoverageRowDto {
    return CsfSubcategoryCoverageRowDtoToJSONTyped(json, false);
}

export function CsfSubcategoryCoverageRowDtoToJSONTyped(value?: CsfSubcategoryCoverageRowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'controlId': value['controlId'],
        'title': value['title'],
        'covered': value['covered'],
        'breadthRatio': value['breadthRatio'],
        'mappedActiveInitiativeCount': value['mappedActiveInitiativeCount'],
        'depthCmmi': value['depthCmmi'],
        'normalizedDepth': value['normalizedDepth'],
        'partialDepth': value['partialDepth'],
        'initiativesContributingToDepthCount': value['initiativesContributingToDepthCount'],
        'compositeScore': value['compositeScore'],
        'compositeCmmi': value['compositeCmmi'],
        'mappedInitiatives': value['mappedInitiatives'] == null ? undefined : ((value['mappedInitiatives'] as Array<any>).map(MappedInitiativeRefDtoToJSON)),
    };
}

